/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function () {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function (event) {
    var cart = event.detail.cart;
    if (cart) {
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { });
  document.addEventListener('theme:scroll:up', e => { });
  document.addEventListener('theme:scroll:down', e => { });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
  // Cart Timer Logic
  function initCartTimer() {
    const timerEl = document.getElementById('CartDrawerTimer');
    if (!timerEl) return;

    const display = timerEl.querySelector('.cart-drawer__timer-display');
    if (!display) return;

    const durationMin = parseInt(timerEl.dataset.timerDuration || 10);

    let targetTime = sessionStorage.getItem('cartTimerTarget');
    // Reset if expired or not set
    if (!targetTime || targetTime < Date.now()) {
      targetTime = Date.now() + durationMin * 60 * 1000;
      sessionStorage.setItem('cartTimerTarget', targetTime);
    }

    // Clear existing interval if any to avoid duplicates
    if (window.cartTimerInterval) clearInterval(window.cartTimerInterval);

    const update = () => {
      const now = Date.now();
      let diff = targetTime - now;
      if (diff < 0) {
        diff = 0;
      }

      const minutes = Math.floor(diff / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      display.textContent = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    update();
    window.cartTimerInterval = setInterval(update, 1000);
  }

  document.addEventListener('theme:cart:init', initCartTimer);
  document.addEventListener('theme:cart:change', initCartTimer);
  document.addEventListener('DOMContentLoaded', initCartTimer);
  // Also run when drawer opens if we can detect it, but changed events usually cover it.



  /*
  // Upsell Add to Cart - Deprecated: Managed in sections/cart-drawer.liquid
  window.addUpsellToCart = function (variantId) {
    const btn = document.querySelector(`button[onclick*='${variantId}']`) || event.target;
    if (btn) {
      btn.innerHTML = '...';
      btn.disabled = true;
    }

    const formData = {
      'items': [{
        'id': variantId,
        'quantity': 1
      }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(response => {
        return response.json();
      })
      .then(item => {
        // Fetch full cart to ensure correct state
        return fetch(window.Shopify.routes.root + 'cart.js')
          .then(res => res.json())
          .then(cart => {
            // Dispatch events with full cart object
            document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cart: cart } }));
            document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));

            // Fallback
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          });
      })
      .then(() => {
        if (btn) {
          btn.innerHTML = 'Ajouté!';
          // Optimistic UI update: Remove item card
          const itemCard = btn.closest('.cart-drawer__upsell-item');
          if (itemCard) {
            setTimeout(() => {
              itemCard.style.transition = 'all 0.3s ease';
              itemCard.style.opacity = '0';
              itemCard.style.transform = 'scale(0.9)';
              setTimeout(() => itemCard.remove(), 300);
            }, 500);
          }
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        if (btn) {
          btn.innerHTML = 'Erreur';
          btn.disabled = false;
        }
      });
  };
  */

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
